export default __webpack_public_path__ + "static/media/clipboard.b095c248.svg";